<template>
    <div class="container-fluid">
        <div class="row py-3">

            <div class="designRowOrga">
                <div class="h3Organization">
                    <h3>Templates</h3>
                </div>
                <router-link to="/templates/create" id="entities-btn"
                             v-if="permissions.includes('create template') && templates.length > 0"
                             class="text-decoration-none btn-container">Create Template
                </router-link>
            </div>
            <div class="tabcontent">
                <div class="fullInputs mb-4 pt-3">
                    <div class="twoInputs">
                        <div class="btnInsideInput">
                            <input type="text" id="free_search"
                                   class="form-control" v-model="search"
                                   placeholder="Search"
                                   autocomplete="off"
                                   @input="searchHandler">

                            <button @click="searchBackEndHandler">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="filterHandler">
                            <option value="" disabled>Sort by Date</option>
                            <option value="asc" key="1">Oldest</option>
                            <option value="desc" key="2">Latest</option>
                        </select>
                    </div>
                </div>
                <div class="table-container" v-if="templates.length > 0">

                    <TableComponent model="templates" name="template" :keys="keys" :thead="thead" :tbody="templates"
                                    updateUrl="/templates/edit"
                                    @sort="sortTemplates"
                                    @update="updateHandler($event)"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="handlePagination($event)" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>
                <div class="d-flex h-75 m-auto" v-else>
                    <div v-if="!isSearch"
                         class="d-flex flex-column justify-content-center align-items-center py-3 w-100">
                        <h3 class="w-100 text-center">You don't have any templates yet</h3>
                        <router-link v-if="permissions.includes('create template')" to="/templates/create"
                                     class="setting-action my-2">Create Template
                        </router-link>
                    </div>
                    <div v-else class="d-flex flex-column justify-content-center align-items-center py-3 w-100">
                        <h3 class="w-100 text-center">No Data</h3>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import {useStore} from "vuex";
    import {onMounted, ref} from "vue";
    import repository from "../../../api-services/repository";
    import moment from 'moment';


    export default {
        name: 'template-page',
        components: {TableComponent, 'Pagination': LaravelVuePagination},
        setup() {
            const store = useStore();
            let templates = ref([]);
            let permissions = ref([]);
            let originalTemplates = ref([]);
            let search = ref('');
            let isSearch = ref(false);
            let sort = ref('desc');
            const laravelData = ref({});
            const thead = ref(['Template Name', 'Created at']);
            const keys = ref(['name', 'createdAt']);
            let state = ref(false);

            onMounted(async () => {
                await store.dispatch('activeTap', 'templates');
                permissions.value = await store.state.auth.permissions;
                await getTemplates(true);
            });

            const searchHandler = (e) => {
                isSearch.value = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                // if (serachedValue !== '') {
                //     isSearch.value = true;
                // } else {
                //     isSearch.value = false;
                // }
                // searchedData = originalTemplates.value.filter((data) => data.name.toLowerCase().indexOf(serachedValue) >= 0);
                // templates.value = searchedData;
            };

            const searchBackEndHandler = async (searchFlag = true) => {
                await getTemplates(searchFlag);
            };

            const filterHandler = (e) => {
                let filterType = e.target.value;
                if (filterType === 'asc') {
                    templates.value.sort(function (a, b) {
                        return new Date(a.created_at) - new Date(b.created_at);
                    });
                } else {
                    templates.value.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });

                }
            };


            const sortTemplates = (e) => {
                let status = !state.value;
                templates.value.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase())) : -(b.id - a.id || b.name.trim().toLowerCase().localeCompare(a.name.trim().toLowerCase()));
                });
                state.value = status;
            };

            const handlePagination = async (pageNumber) => {
                await getTemplates(pageNumber);
            };

            const updateHandler = async (event) => {
                templates.value = templates.value.filter((template) => {
                    return template.id !== event
                })
                await getTemplates(true);
            };

            const getTemplates = async (page = 1) => {

                try {
                    let templatesData = await repository.index('templates', search.value, sort.value, true, page);
                    if (process.env.VUE_ENV === 'development')
                        console.log(templatesData.data.data.data)
                    laravelData.value = templatesData.data.data;
                    templates.value = templatesData.data.data.data;
                    originalTemplates.value = templatesData.data.data.data;

                    templates.value = templates.value.map((temp) => {
                        temp.createdAt = moment(temp.created_at).format('D-MMM-YYYY');
                        return temp;
                    })
                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                        console.log({e})
                }

            };

            return {
                templates,
                originalTemplates,
                search,
                sort,
                laravelData,
                keys,
                thead,
                state,
                isSearch,
                updateHandler,
                sortTemplates,
                searchHandler,
                filterHandler,
                getTemplates,
                handlePagination,
                permissions,
                searchBackEndHandler
            }
        }
    }
</script>

<style scoped>

    .content {
        display: block;
        padding: 18px;
        height: 75vh;
        overflow-y: auto;
        border-top: none;
        background-image: linear-gradient(#042230, #082d3c);
        border-radius: 18px;
    }
</style>